// @react
import React from 'react'
// @types
import type { ReactElement } from 'react'
// @libraries
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
// @components
import TextLink from '@bit/atd.web.text-link'
import colors from '@bit/atd.web.colors'
// @utils
import Helper from 'utils/Helper.class'

type PropTypes = {
  title: string
  startDate: number
  endDate: number
  url?: string
  label?: string
}

const useStyles = makeStyles(() => ({
  root: {},
  title: {
    color: colors.textActive,
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '22px',
  },
  description: {
    color: colors.statusAlert,
    fontSize: '11px',
    lineHeight: '16px',
    marginTop: '3px',
  },
  dates: {
    fontWeight: 600,
  },
  link: {
    marginTop: '6px',
  },
}))

const MembershipItem = ({
  title,
  startDate,
  endDate,
  url,
  label,
}: PropTypes): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()

  /******************************************
   * RENDERS
   ******************************************/

  return (
    <div className={classes.root}>
      {/* Title */}
      <Typography className={classes.title} component={'h4'}>
        {title}
      </Typography>

      {/* Description */}
      <Typography className={classes.description} component={'p'}>
        EFFECTIVE:{' '}
        <span className={classes.dates}>
          {Helper.condensedDateFormatter(startDate)} -{' '}
          {Helper.condensedDateFormatter(endDate)}
        </span>
      </Typography>

      {url && (
        <TextLink
          className={classes.link}
          size={'small'}
          variant="standalone"
          target="_blank"
          href={url}
        >
          {label}
        </TextLink>
      )}
    </div>
  )
}

export default MembershipItem
